const __CLIENT_TYPE__ = process.env.CLIENT_TYPE;
const __API_JUNO__ = process.env.API_JUNO;
const __API_ALB_V1__ = process.env.API_ALB_V1;
const __API_ALB_V2__ = process.env.API_ALB_V2;
const __API_LK__ = process.env.API_LK;
const __API_WEB__ = process.env.BUILD_ENV === 'development' ? 'https://webapi-preprod.lenskart.com' : 'https://webapi.lenskart.com';
const __YOTPO_API_KEY__ = process.env.BUILD_ENV === 'development' ? 'H8YJ4tBeZCQjT0UJVvyfiCm7Dyl6v0UNCKwZXywm' : 'yRLOxOqElIsw88TIlZ1GZE9GxjFBP5oNzH49HEnC';
const environment = {
  development: {
    isProduction: false,
    // assetsPath: `http://${process.env.HOST || 'localhost'}:${+process.env.PORT || 4001}/dist/${__CLIENT_TYPE__ === 'mobile' ? 'mobile/' : 'desktop/'}`
    // assetsPath: __CLIENT_TYPE__ === 'mobile' ? '/' : '/dist/desktop/'
    assetsPath: '/'
  },
  production: {
    isProduction: true,
    assetsPath: `${__CLIENT_TYPE__ === 'mobile' ? 'https://static1.lenskart.com/media/mobile/react/' : 'https://static1.lenskart.com/media/desktop/js/dist-prod/'}`
  }
}[process.env.BUILD_ENV || 'development'];

// Msite specific globals will go here.
const msiteGlobals = {
  maxShortList: { count: 10, message: 'You have exceeded limit of saving products: 10' },
  appXApiClients: ['android', 'ios'],
  recViewList: { noOfDisplayProducts: 11 },
  viewImagesList: ['frame_shape_id', 'frametype_id', 'frame_size_id'],
  filterCdnPath: 'https://static.lenskart.com/images/cust_mailer/',
  recCatList: { noOfCatIds: 5, noOfDisplayProducts: 10 },
  cmsCategoryArray: ['eyeglasses', 'sunglasses', 'power-sunglasses', 'premium-eyeglasses', 'contact-lenses'],
  orderStatusApiUrl: 'https://static1.lenskart.com/media/mobile/universal/json/order_status.json'
};
//  ditto auth api
// const dittoSecretKey = '985b799a13ad811468ede9f20fc8bb2e802ce2a48712639ecccb7f2a39fb23f1abb027db2ac171823c77b0843877b2acad4c2e16ae0f3cfaf6b8a68881bcbeed';
// const dittoAccessKey = '864c62d7894d1f12';

// Msite specific api path will goes here.
const msiteApiPath = {
  homePageJson: `https://static1.lenskart.com/media/mobile/universal/json${process.env.BUILD_ENV === 'development' ? '/stage' : ''}/home.json`,
  verifyOtp: `${__API_JUNO__}/v2/customers/verifyOtp`,
  subCatApiUrl: `${__API_JUNO__}/juno/services/v1/subcategory`,
  returnConfig: 'http://lenskart.com:8081/static/return-config.json',
  getOrdersList: `${__API_JUNO__}/v2/orders`,
};
// Common api paths will goes here for msite/desktop
let apiPath = {
  userSession: `${__API_JUNO__}/v2/sessions`,
  albUserSession: `${__API_ALB_V2__}/v2/sessions`,
  redis: `${__API_LK__}/juno/services/v1/redis?keys=`,
  albRedis: `${__API_ALB_V1__}/juno/services/v1/redis?keys=`,
  dataProduct: `${__API_JUNO__}/juno/services/v1/product/`,
  albDataProduct: `${__API_ALB_V1__}/juno/services/v1/product/`,
  dataProductUnSecure: `${__API_LK__}/juno/services/v1/product/`,
  lensPackages: `${__API_LK__}/juno/services/v1.1/product/`,
  subscriptionDiscounts: `${__API_LK__}/juno/services/v1.1/subscriptions/discount`,
  estimateDelivery: 'https://developer.lenskart.com/api/v1/shipping/estimate',
  categorySearch: `${__API_LK__}/juno/services/v1/category/search/query/`, // vincent?page=0
  categorySearchFilter: `${__API_LK__}/me/index/searchfilters`, // ?query=vincent
  dataCategory: `${__API_LK__}/juno/services/v1/category/`,
  albDataCategory: `${__API_ALB_V1__}/juno/services/v1/category/`,
  categoryCarouselUrl: `${__API_JUNO__}/juno/services/v1/carouselbanner?category=`,
  filterDataApi: `${__API_LK__}/juno/services/v1/filters/`,
  homePageJson: `https://static1.lenskart.com/media/desktop/json${process.env.BUILD_ENV === 'development' ? '/stage' : ''}/revamp_home.json`,
  // mainNavigation: __API_LK__ + '/getmenu/revamp_navigation',
  mainNavigation: process.env.BUILD_ENV === 'development' ? 'https://static.lenskart.com/media/desktop/json/navigation.json' : __API_LK__ + '/getmenu/revamp_navigation',
  mobileNavigationJsonUrl: `https://static1.lenskart.com/media/mobile/universal/json${process.env.BUILD_ENV === 'development' ? '/stage' : ''}/navigation_menu.json`,
  userAuthenticate: `${__API_JUNO__}/v2/customers/authenticate`,
  userAddress: `${__API_JUNO__}/v2/customers/me/addresses/`,
  saveUpdateDitto: `${__API_LK__}/juno/services/v1/ditto`,
  lensOnlyShippinglocation: `${__API_LK__}/api/v1/shipping/location/`,
  deleteUserAddress: `${__API_JUNO__}/v2/customers/me/`,
  registerCustomer: `${__API_JUNO__}/v2/customers/register`,
  forgotPasswordToken: `${__API_JUNO__}/v2/customers/account/tokens`,
  submitNumber: `${__API_LK__}/juno/services/v1/campaign/MobileData`,
  socialAuth: `${__API_JUNO__}/v2/customers/socialauthenticate/`,
  updateCartItem: `${__API_JUNO__}/v2/carts/items/`,
  locationData: `${__API_JUNO__}/me/index/countrystate`,
  pincodeCheck: `${__API_JUNO__}/me/index/checkpincode/`,
  paymentMethod: `${__API_JUNO__}/v3/payment-methods`,
  orderPayment: `${__API_JUNO__}/v2/orderpayment/`,
  // requestPaymentUrl: __API_LK___SECURE + '/me/index/requestPayment',
  applyGV: `${__API_JUNO__}/v2/carts/giftVoucher/`,
  storeCredit: `${__API_JUNO__}/v2/money/store-credits/`,
  applySC: `${__API_JUNO__}/v2/carts/`,
  cartApi: `${__API_JUNO__}/v2/carts`,
  albCartApi: `${__API_ALB_V2__}/v2/carts`,
  reOrderCartApi: `${__API_JUNO__}/v2/carts/recart/`,
  breadcrumb: `${__API_LK__}/me/index/breadcrumb?id=`,
  getUserInfo: `${__API_JUNO__}/v2/customers/me`,
  albGetUserInfo: `${__API_ALB_V2__}/v2/customers/me`,
  wishlist: `${__API_LK__}/juno/services/v1/wishlist`,
  usersSavedCards: `${__API_JUNO__}/v2/saved-cards`,
  checkDeliveryOption: `${__API_JUNO__}/v2/carts/expressdelivery/deliveryOptions?pincode=`,
  updateDeliveryOption: `${__API_JUNO__}/v2/carts/expressdelivery/updateDeliveryOption/`,
  oosSubscription: `${__API_LK__}/juno/services/v1/product/oos-subscription`,
  // optimizelyExperiments: 'https://static.lenskart.com/experiment/optimizely.json?' + Date.now(),
  saveShippingAddress: `${__API_JUNO__}/v2/carts/shippingAddress`,
  homeEyeCheckup: 'https://hto.lenskart.com/HTO/api/HTOService/slot',
  emailDitto: `${__API_LK__}/juno/services/v1/ditto/mail`,
  enterMyPower: 'https://www.lenskart.com/instantpfulink.php',
  getOrderDetails: `${__API_JUNO__}/v2/orders/`,
  getOrdersList: `${__API_JUNO__}/v3/orders`,
  getSavedPrescription: `${__API_JUNO__}/v2/prescriptions`,
  recentOrders: `${__API_JUNO__}/v2/orders/recentOrders`,
  latestOrder: `${__API_JUNO__}/v2/orders/latest/order`,
  uploadprescfile: `${__API_JUNO__}/me/index/uploadprescfile`,
  validateSession: `${__API_JUNO__}/v2/sessions/validate`,
  albValidateSession: `${__API_ALB_V2__}/v2/sessions/validate`,
  userLocation: `${__API_JUNO__}/juno/services/v1/configuration/location?ip=`,
  albUserLocation: `${__API_ALB_V1__}/juno/services/v1/configuration/location?ip=`,
  varnishApi: `${__API_LK__}/ajax/index/dummyvar`,
  dittoProfile: `${__API_JUNO__}/v2/utility/ditto/customer/`,
  changePassword: `${__API_JUNO__}/v2/customers/account/resetpassword`,
  giftVoucherBalance: `${__API_JUNO__}/v2/money/gift-vouchers/code?giftVoucherCode=`,
  mobileLoginAccountInfo: `${__API_JUNO__}/v2/customers/accountsInfo`,
  editNeft: `${__API_JUNO__}/v2/orders/neft/savedetails`,
  resetPassword: `${__API_JUNO__}/juno-customer/v2/customers/account/forgotpassword`,
  mobileLoginSendOTP: `${__API_JUNO__}/v2/customers/sendOtp`,
  mobileLoginAuthenticateMobileUser: `${__API_JUNO__}/v2/customers/authenticate/mobile`,
  magentoCategory: `${__API_JUNO__}/me/index/carouselbanner?category=`,
  mobileEmailFetch: `${__API_JUNO__}/v2/customers/accounts?telephone=`,
  mobileEmailLink: `${__API_JUNO__}/v2/customers/accountVerification/sendEmail`,
  cmsPages: 'https://www.lenskart.com/me/catalog/cmsPage/id/',
  jsonPath: `https://static1.lenskart.com/media/desktop/json/${process.env.BUILD_ENV === 'development' ? 'stage/' : ''}`,
  captchaUrl: `${__API_LK__}/me/index/getcaptcha/`,
  countryCode: `${__API_WEB__}/api/country/`,
  apiCampaign: `${__API_WEB__}/api/campaign?client=${__CLIENT_TYPE__ === 'mobile' ? 'msite' : 'desktop'}`,
  dittoAuth: `${__API_JUNO__}/v2/utility/ditto/customer/authentication/token/`,
  reviewProduct: `${__API_JUNO__}/v2/products/product/`,
  orderStatusConfig: 'https://static2.lenskart.com/media/desktop/json/order-status-config.json',
  generateOtp: `${__API_JUNO__}/v2/utility/otp`,
  guestOrders: `${__API_JUNO__}/v2/orders/guest`,
  yotpoSiteReview: `https://api.yotpo.com/products/${__YOTPO_API_KEY__}/yotpo_site_reviews/bottomline`,
  checkWhatsappConsent: `${__API_JUNO__}/v2/customers/checkWhatsAppOpingStatus`,
  setWhatsappConsent: `${__API_JUNO__}/v2/customers/whatsAppOpting`,
  frameSize: 'https://lenskart-prod.firebaseapp.com/api/v1/frame-size/calculate',
  storeFrameSize: 'https://lenskart-prod.firebaseapp.com/api/v1/frame-size/upload_image'
};

apiPath = __CLIENT_TYPE__ === 'mobile' ? Object.assign(apiPath, msiteApiPath) : apiPath;

let config = Object.assign(
  {
    host: process.env.HOST || 'localhost',
    port: process.env.PORT || 3000,
    apiHost: process.env.APIHOST || 'localhost',
    apiPort: process.env.APIPORT,
    app: {
      title: 'Lenskart.com® - First Eyeglasses Frame FREE',
      description: 'Shop online for Sunglasses, Eyeglasses and Contact Lenses for men &amp; women and Get upto 50% Flat Discount at lenskart.com.  ✓FREE shipping ✓Cash on Delivery ✓14 Days Return.​',
      head: {
        titleTemplate: '%s'
      }
    },
    categoryPageSize: 15,
    apiPath,
    rbiMarketPlaceConfig: {
      type: __CLIENT_TYPE__,
      defaultLogo: 'https://static1.lenskart.com/media/desktop/img/site-images/logo.svg',
    },
    ditto: {
      serverUrl: 'https://vto.lenskart.api.ditto.com',
      accessKeyId: '',
      signature: '',
      modelDittoId: 'ditto_model_female_04',
      modelDittoSignature: '',
      sku: '122548',
      disableScale: true,
      vtoUrl: 'https://vto.lenskart.api.ditto.com/api/1.3/dittos/'
    },
    sixOversix: {
      options: {
        fullPage: true,
        width: '100vw',
        themeColor: '#5FB8E3'
      },
      clientId: process.env.BUILD_ENV === 'development' ? '093f4b80946e12dfd1f5a3552fd5acbf' : 'aef53fd8f1d4fe16b40e085cce94ed35'
    },
    defaultFrameCategory: {
      eyeglasses: '/eyeglasses/brands/vincent-chase-eyeglasses.html#filter_frame_size_id%3D',
      sunglasses: '/sunglasses/promotions/vc-new-arrivals.html#filter_frame_size_id%3D'
    },
    searchBarConfig: {
      url: 'https://search.unbxdapi.com/{0}/autosuggest?q=',
      siteName: 'lenskart_com-u1418736834941',
      APIKey: '6c1aa3ba216de83b8340d2d4d891d309',
      inFields: {
        count: 2,
      },
      topQueries: {
        count: 5,
      },
      keywordSuggestions: {
        count: 2,
      },
      popularProducts: {
        count: 5,
      },
    },
    yotpoConfig: {
      apiKey: __YOTPO_API_KEY__,
      instaGalleries: {
        pdp: process.env.BUILD_ENV === 'development' ? '5cd2e4b093bf900cc16e06c3' : '5cd56a15a230aa3b9199f193',
        home: process.env.BUILD_ENV === 'development' ? '5cc82cae6830580008ec0594' : '5cc6ae7593bf9010d734bc9d',
        shop: process.env.BUILD_ENV === 'development' ? '5cd3edb858bdd30009dca8dc' : '5cd56a30f1b75c389da04c81'
      }
    },
    adobeAssets: `https://assets.adobedtm.com/7e0d09158b56a4fed4b0d60d94ec593cb6934f0d/satelliteLib-ada03ad1d0e028a8db3fcbb3a6efd225336230c2${process.env.BUILD_ENV === 'development' ? '-staging' : ''}.js`
  },
  environment
);

'#if CLIENT_TYPE === "mobile"'; // eslint-disable-line
config = Object.assign(config, { msiteGlobals });
'#endif'; // eslint-disable-line

module.exports = config;
